import { useMemo, useState } from 'react'
// antd
import { Button, Modal } from 'antd';
// helpers
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import axios from 'axios'
import { isUndefined } from '@uirouter/react'
import { useQuery } from 'react-query'
import ModalLocation from './ModalLocation';
import { FaMapLocationDot } from "react-icons/fa6";
import styles from './styles.module.scss'

const getLocation = async (ip) => {
  const { data } = await axios({
    url: `http://ip-api.com/json/${ip}?lang=es`,
  })

  if (isUndefined(data)) throw new Error('')

  return data
}

const Cell: React.FC<{ record: any }> = ({ record }) => {
  const { ipAddress } = record as { ipAddress: string }
  const [locationPath, setPath] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    if (!isEmpty(`${get(locationPath, "lat", "")}`) && !isEmpty(`${get(locationPath, "lon", "")}`)) setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const { data } = useQuery(`LocationIp-${ipAddress}`, {
    queryFn: () => getLocation(ipAddress.split(":", 1)),
    onSuccess: (data) => setPath(data)
  })

  const props = {
    container: {
      className: styles.truncateCell,
      onClick: e => {
        e.stopPropagation()
      }
    },
  }

  const getPath = useMemo(() => {
    const path = [get(locationPath, "country", ""),
    get(locationPath, "regionName", ""),
    get(locationPath, "city", "")].filter((str) => !isEmpty(str)).join(" / ")

    return path
  }, [locationPath])

  const spanStyle = {
    display: 'inline-block',
    maxWidth: '85%',
    whiteSpace: 'nowrap' as 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }

  return (
    <div {...props.container} title={getPath}>
      <span style={spanStyle}>{getPath}</span>
      <Button type="link" onClick={showModal} icon={<FaMapLocationDot />} shape="circle" />
      <ModalLocation handleCancel={handleCancel} lat={get(locationPath, "lat", "")} lng={get(locationPath, "lon", "")}
        open={isModalOpen}
      />
    </div>
  )
}

const LocationCell: React.FC = (ip: string, record) => {
  if (ip === '' || !ip) return null

  return <Cell record={record} />
}

export default LocationCell
